module.exports = __webpack_public_path__ + "static/media/003_universe.eb428558.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp_org/003_universe.png
// module id = 539
// module chunks = 0